import { Box, useStyleConfig } from '@chakra-ui/react';

import RouteLink, { RouteLinkProps, RouteProps } from '@/components/RouteLink';
import { RegistryPackageDocsPage } from '@/graphql/upbound-graphql';

const getActiveStyles = (currentPage: string | undefined, selectedPage: RegistryPackageDocsPage | undefined) => {
  if (currentPage?.toLowerCase().replace(' ', '-') === selectedPage?.name.toLowerCase().replace(' ', '-')) {
    return { color: 'purple.0' };
  }

  return {};
};

const DocsTabTreeLink: React.FC<
  RouteLinkProps & {
    variant: 'root' | 'child';
    params: Params<RouteProps['packageDocsTab']>;
    selectedPage: RegistryPackageDocsPage | undefined;
  }
> = ({ children, variant, selectedPage, params, noOfLines = 2, ...props }) => {
  const styles = useStyleConfig('TreeLink', { variant });

  const activeStyles = getActiveStyles(params.pageName, selectedPage);

  return (
    <RouteLink
      sx={{ ...styles, ...activeStyles }}
      to="packageDocsTab"
      params={params}
      {...props}
      scroll={false}
      shallow={false}
    >
      <Box noOfLines={noOfLines}>{children}</Box>
    </RouteLink>
  );
};

export default DocsTabTreeLink;
